// 1. GlobalStyles.js

import { alpha } from '@mui/material'
import GlobalStyles from '@mui/system/GlobalStyles'
import { fontFamilies, getResponsiveSize } from 'theme/styles.utils'
import { important } from 'utils/styles/stylesUtils'

export const CustomGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={(theme) => ({
        html: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          height: '100%',
          width: '100%',
          maxHeight: '100vh',
          WebkitOverflowScrolling: 'touch',
          fontSize: Math.min(getResponsiveSize(16), 20),
          scrollBehavior: 'smooth',
          scrollPaddingTop: getResponsiveSize(120, 'px'),
          ':target': {
            backgroundColor: 'yellow',
          },
        },
        '.snackbar-custom': {
          top: important(getResponsiveSize(60, 'px')),
          '& .SnackbarItem-message': {
            fontSize: getResponsiveSize(0.85, 'rem'),
          },
          '& svg': {
            fontSize: important(getResponsiveSize(20, 'px')),
          },
        },
        '*, *::before, *::after': {
          boxSizing: 'inherit',
        },
        body: {
          height: '100%',
          width: '100%',
          fontFamily: fontFamilies.cond,
          minWidth: '300px',
        },
        '#root': {
          height: '100%',
          width: '100%',
        },
        [theme.breakpoints.up('sm')]: {
          '#root': {
            maxWidth: '100vw',
          },
        },
        'input:-webkit-autofill, input:-webkit-autofill:hover,input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus':
          {
            fontSize: '1.125rem !important',
            fontWeight: 700,
            border: 0,
            WebkitTextFillColor: theme.palette.text.primary,
            WebkitBoxShadow: `0 0 0px 1000px ${alpha(theme.palette.primary.light, 0)} inset`,
            transition: 'all 5000s ease-in-out 0s',
          },
        '.fitVideos': {
          position: 'relative',
          height: 0,
          '& iframe': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          },
        },
        '.gridListItem': {
          borderRight: `1px solid ${theme.palette.background.default}`,
          borderBottom: `1px solid ${theme.palette.background.default}`,
          '&:nth-of-type(3n+0)': {
            borderRight: 'none',
          },
          '&:nth-last-of-type(-n+3)': {
            borderBottom: 'none',
          },
          '&:last-child': {
            borderRight: 'none',
          },
        },
        '.carousel': {
          '& .carousel-slider': {
            overflow: 'initial!important',
          },
          '& .carousel': {
            '& .slider': { maxHeight: '80vh' },
            '& .slide': { padding: '2px' },
            '& .control-arrow': {
              '&.control-prev': {
                left: -4,
                '&:before': {
                  borderRightColor: `${theme.palette.grey[400]}!important`,
                },
              },
              '&.control-next': {
                right: -4,
                '&:before': {
                  borderLeftColor: `${theme.palette.grey[400]}!important`,
                },
              },
            },
            '& .thumbs-wrapper': {
              textAlign: 'center',
            },
            '& .thumb': {
              maxWidth: 100,
              height: 100,
              padding: 0,
              display: 'inline-flex',
              borderWidth: 3,
              borderColor: theme.palette.grey[200],
              '&.selected, &:hover': {
                borderColor: theme.palette.grey[400],
              },
              '& img': {
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              },
            },
          },
        },
        '.SelectButton-icon': {
          '& > *:first-of-type': {
            fontSize: `${getResponsiveSize(0.8)}rem`,
          },
        },
      })}
    />
  )
}
